export const ZDP_SYNC_SETTINGS = 'syncSettings';
export const ZDP_AUTH_SETUP = 'ZDP/authSetup';
